import WebServiceRequest from "../../Api/WebServiceRequest";

class updateAPlan extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Plan/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default updateAPlan;
